<template>
  <div class="receipt-print-setting-container">
    <el-card class="box-card">
      <div slot="header">
        <span>{{ $t('receiptPrintSetting.title') }}</span>
      </div>

      <el-alert :title="$t('receiptPrintSetting.tip')" type="info" show-icon :closable="false" class="tip-alert">
      </el-alert>

      <el-form ref="settingForm" :model="formData" :rules="rules" label-width="120px" v-loading="loading"
        class="setting-form">
        <el-form-item :label="$t('receiptPrintSetting.receiptName')" prop="printName">
          <el-input v-model="formData.printName" maxlength="128"
            :placeholder="$t('receiptPrintSetting.receiptNamePlaceholder')">
          </el-input>
          <div class="form-tip">{{ $t('receiptPrintSetting.receiptNameTip') }}</div>
        </el-form-item>

        <el-form-item :label="$t('receiptPrintSetting.content')">
          <el-input type="textarea" :rows="5" v-model="formData.content"
            :placeholder="$t('receiptPrintSetting.contentPlaceholder')">
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('receiptPrintSetting.qrImg')">
          <upload-image-url ref="uploader" :image-count="1" @notifyUploadCoverImage="handleImageChange">
          </upload-image-url>
          <div class="form-tip">{{ $t('receiptPrintSetting.qrImgTip') }}</div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="submitting">
            {{ $t('receiptPrintSetting.save') }}
          </el-button>
          <el-button @click="resetForm">
            {{ $t('receiptPrintSetting.reset') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { queryFeePrintSpec, saveFeePrintSpec, updateFeePrintSpec } from '@/api/system/feePrintSpecManageApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'ReceiptPrintSetting',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      loading: false,
      submitting: false,
      // 当前小区已有的收据打印配置（specCd=2020），为空则新增
      existPrintId: '',
      formData: {
        printName: '',
        content: '',
        qrImg: ''
      },
      rules: {
        printName: [
          { max: 128, message: this.$t('receiptPrintSetting.nameMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadSetting()
  },
  methods: {
    async loadSetting() {
      try {
        this.loading = true
        const { data } = await queryFeePrintSpec({
          page: 1,
          row: 1,
          specCd: '2020'
        })
        if (data && data.length > 0) {
          this.existPrintId = data[0].printId
          this.formData.printName = data[0].printName || ''
          this.formData.content = data[0].content || ''
          this.formData.qrImg = data[0].qrImg || ''
          if (this.formData.qrImg) {
            this.$nextTick(() => {
              this.$refs.uploader.setImages([this.formData.qrImg])
            })
          }
        }
      } catch (error) {
        this.$message.error(this.$t('receiptPrintSetting.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleImageChange(images) {
      if (images && images.length > 0) {
        this.formData.qrImg = images[0]
      } else {
        this.formData.qrImg = ''
      }
    },
    submitForm() {
      this.$refs.settingForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const postData = {
            specCd: '2020',
            printName: this.formData.printName,
            content: this.formData.content,
            qrImg: this.formData.qrImg,
            communityId: getCommunityId()
          }
          if (this.existPrintId) {
            await updateFeePrintSpec({
              ...postData,
              printId: this.existPrintId
            })
          } else {
            const res = await saveFeePrintSpec(postData)
            // 新增后刷新，拿到 printId 供下次更新
            if (res && res.data) {
              this.existPrintId = res.data
            }
            if (!this.existPrintId) {
              await this.loadSetting()
            }
          }
          this.$message.success(this.$t('receiptPrintSetting.saveSuccess'))
        } catch (error) {
          this.$message.error(error.message || this.$t('receiptPrintSetting.saveFailed'))
        } finally {
          this.submitting = false
        }
      })
    },
    resetForm() {
      this.formData = {
        printName: '',
        content: '',
        qrImg: ''
      }
      this.$refs.uploader.clear()
      this.$refs.settingForm.clearValidate()
    }
  }
}
</script>

<style lang="scss" scoped>
.receipt-print-setting-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .tip-alert {
    margin-bottom: 20px;
  }

  .setting-form {
    max-width: 640px;
  }

  .form-tip {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    margin-top: 4px;
  }
}
</style>
